<template>
  <b-form-group
    label="Metin"
    label-for="content"
  >
    <b-form-textarea
      id="content"
      v-model="itemData.content"
      placeholder="Metin"
    />
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormTextarea } from 'bootstrap-vue'

export default {
  name: 'TitleText',
  components: { BFormTextarea, BFormGroup },
  computed: {
    itemData() {
      return this.$store.getters['carousel/dataItem']
    },
  },
}
</script>
